import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";

const initialState: any = {
  imgloading: false,
  loading: false,
  data: {},
  message: "",
  success: false,
  profileimageUrl: "",
  updateMessage: "",
  addcustomerloading: false,
  updateloading: false,
  addUpdateloading: false,
  addUpdateSuccess: false,
  deletecustomerloading: false,
};

const customersSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    getCustomers(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getCustomerSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getCustomerFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
        state.data = {};
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    addCustomer(state, action: PayloadAction<ApiResponse>) {
      state.addcustomerloading = true;
      state.message = "";
    },
    addCustomerSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addcustomerloading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    addCustomerFailed(state, action: PayloadAction<ApiResponse>) {
      state.addcustomerloading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    updateCustomer(state, action: PayloadAction<ApiResponse>) {
      state.updateloading = true;
      state.message = "";
    },
    updateCustomerSuccess(state, action: PayloadAction<ApiResponse>) {
      state.updateloading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    updateCustomerFailed(state, action: PayloadAction<ApiResponse>) {
      state.updateloading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    addUpdateCustomer(state, action: PayloadAction<ApiResponse>) {
      state.addUpdateloading = true;
      state.addUpdateSuccess = false;
      state.message = "";
    },
    addUpdateCustomerSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addUpdateloading = false;
      state.message = action.payload.message;
      state.addUpdateSuccess = action.payload.success;
    },
    addUpdateCustomerFailed(state, action: PayloadAction<ApiResponse>) {
      state.addUpdateloading = false;
      state.message = action.payload.message;
      state.addUpdateSuccess = action.payload.success;
    },
    clearAddUpdateCustomer(state) {
      state.addUpdateloading = false;
      state.addUpdateSuccess = false;
    },
    deleteCustomer(state, action: PayloadAction<ApiResponse>) {
      state.deletecustomerloading = true;
      state.message = "";
    },
    deleteCustomerSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deletecustomerloading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    deleteCustomerFailed(state, action: PayloadAction<ApiResponse>) {
      state.deletecustomerloading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getIdentityTypes(state, action: PayloadAction<ApiResponse>) {
      // state.loading = true;
      state.message = "";
    },
    getIdentityTypesSuccess(state, action: PayloadAction<ApiResponse>) {
      // state.loading = false;
      state.options = action.payload;
      state.success = action.payload.success;
    },
    getIdentityTypesFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getprofileImageUrl(state, action: PayloadAction<ApiResponse>) {
      state.profileimgloading = true;
      state.profileimageUrl = "";
    },
    getprofileImageUrlSuccess(state, action: PayloadAction<ApiResponse>) {
      state.profileimgloading = false;
      state.profileimageUrl = action.payload.photoURL;
    },
    getprofileImageUrlFailed(state, action: PayloadAction<ApiResponse>) {
      state.profileimgloading = false;
      state.profileimageUrl = "";
    },
    getfrontIdImageUrl(state, action: PayloadAction<ApiResponse>) {
      state.frontidimgloading = true;
      state.frontIdimageUrl = "";
    },
    getfrontIdImageUrlSuccess(state, action: PayloadAction<ApiResponse>) {
      state.frontidimgloading = false;
      state.frontIdimageUrl = action.payload.photoURL;
    },
    getfrontIdImageUrlFailed(state, action: PayloadAction<ApiResponse>) {
      state.frontidimgloading = false;
      state.frontIdimageUrl = "";
    },
    getbackIdImageUrl(state, action: PayloadAction<ApiResponse>) {
      state.backidimgloading = true;
      state.backIdimageUrl = "";
    },
    getbackIdImageUrlSuccess(state, action: PayloadAction<ApiResponse>) {
      state.backidimgloading = false;
      state.backIdimageUrl = action.payload.photoURL;
    },
    getbackIdImageUrlFailed(state, action: PayloadAction<ApiResponse>) {
      state.backidimgloading = false;
      state.backIdimageUrl = "";
    },
    changeBrandStatus(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    changeBrandStatusSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    changeBrandStatusFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.mesage = action.payload.message;
      state.success = action.payload.success;
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.updateMessage = "";
      state.deleteMessage = "";
      state.profileimageUrl = "";
      state.frontIdimageUrl = "";
      state.backIdimageUrl = "";
      state.frontidimgloading = "";
      state.backidimgloading = "";
    },
  },
});

//Actions
export const customersActions = customersSlice.actions;

//Selectors
export const getCustomersData = (state: RootState) => state.customers.data;
export const selectIsLoading = (state: RootState) => state.customers.loading;
export const selectDeleteLoading = (state: RootState) =>
  state.customers.deletecustomerloading;
export const selectupdatecustomerLoading = (state: RootState) =>
  state.customers.updateloading;
export const selectIsaddcustomerloading = (state: RootState) =>
  state.customers.addcustomerloading;
export const selectIsSuccess = (state: RootState) => state.customers.success;
export const selectMessage = (state: RootState) => state.customers.message;
export const selectUpdateMessage = (state: RootState) =>
  state.customers.updateMessage;

export const selectAddUpdateLoading = (state: RootState) =>
  state.customers.addUpdateloading;
export const selectAddUpdateSuccess = (state: RootState) =>
  state.customers.addUpdateSuccess;

export const profileimageLoading = (state: RootState) =>
  state.customers.profileimgloading;
export const selectprofileImageUrl = (state: RootState) =>
  state.customers.profileimageUrl;

export const frontidimgloading = (state: RootState) =>
  state.customers.frontidimgloading;
export const selectfrontIdImageUrl = (state: RootState) =>
  state.customers.frontIdimageUrl;

export const backidimgloading = (state: RootState) =>
  state.customers.backidimgloading;
export const selectbackIdImageUrl = (state: RootState) =>
  state.customers.backIdimageUrl;

export const selectOptions = (state: RootState) => state.customers.options;

//Reducers
const customersReducer = customersSlice.reducer;
export default customersReducer;
